import { ContactType_Enum } from 'src/types/enums';
import NotificationChannel_Enum from 'src/types/notification/scenarios/scenario-details';

export function useMapChannelsToFlags(channels: ContactType_Enum[]): NotificationChannel_Enum {
	const hasEmail = channels.includes(ContactType_Enum.Email);
	const hasText = channels.includes(ContactType_Enum.Text);
	const hasWhatsApp = channels.includes(ContactType_Enum.WhatsApp);

	if (hasEmail && hasText && hasWhatsApp) {
		return NotificationChannel_Enum.Email | NotificationChannel_Enum.Sms | NotificationChannel_Enum.WhatsApp;
	} else if (hasEmail && hasText) {
		return NotificationChannel_Enum.Email | NotificationChannel_Enum.Sms;
	} else if (hasEmail && hasWhatsApp) {
		return NotificationChannel_Enum.Email | NotificationChannel_Enum.WhatsApp;
	} else if (hasEmail) {
		return NotificationChannel_Enum.Email;
	} else if (hasText && !hasWhatsApp) {
		return NotificationChannel_Enum.Sms;
	} else if (hasWhatsApp && !hasText) {
		return NotificationChannel_Enum.WhatsApp;
	} else if (hasText && hasWhatsApp) {
		return NotificationChannel_Enum.Sms | NotificationChannel_Enum.WhatsApp;
	}
	return NotificationChannel_Enum.None;
}
